import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useTranslation } from "react-i18next";

const Contact = () => {
  const { t } = useTranslation();
  return (
    <Container maxWidth="sm">
      <Box mt={5} textAlign="center">
      <Typography variant="h4" gutterBottom>
  {t("contact_us")}
</Typography>
<Typography variant="body1">
  {t("contact_us_description")}
</Typography>
        <Typography variant="h6" color="primary" mt={2}>
          <a href="mailto:ganttmaster@ganttmaster.com" style={{ textDecoration: 'none', color: 'inherit' }}>
            ganttmaster@ganttmaster.com
          </a>
        </Typography>
      </Box>
    </Container>
  );
};

export default Contact;
